export default "__VITE_ASSET__BByaZY9c__"